export default "__VITE_ASSET__ClkWtWqa__"